import * as Suite from "./Suite/index.js";
import * as MultipleTypeAhead from "./MultipleTypeAhead/index.js";
import * as Attachment from "./Attachment/index.js";
/** CoStar.Api.ExternalApi.ViewModels.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsAndEntertainment"] = 8] = "SportsAndEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["Unknown"] = 14] = "Unknown";
    PropertyType[PropertyType["Student"] = 31] = "Student";
})(PropertyType || (PropertyType = {}));
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.ExternalApi.ViewModels.AreaMeasure */
export { AreaMeasure };
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.ExternalApi.ViewModels.CurrencyType */
export { CurrencyType };
export { Suite, MultipleTypeAhead, Attachment };
